import { Navigate } from 'react-router-dom';
import { MAIN_PAGE, SCHEDULE_PAGE } from 'shared/consts';
import { useLastSearchQuery } from 'shared/hooks';

export const InitialRedirect = () => {
  const { getLastSearchQuery } = useLastSearchQuery();
  const lastSearchQuery = getLastSearchQuery();

  if (lastSearchQuery) {
    return <Navigate to={SCHEDULE_PAGE} replace />;
  }

  return <Navigate to={MAIN_PAGE} replace />;
};
